'use strict';

import { BaseElement } from '../../interfaces/BaseElement';
import { setLordIcon } from '../../../lordicon';
import { changeLangToCurrent } from '../langSwitcher/langSwitcher';
import { isMobile } from '../../../settings';

export class Sound {
	static music = null;
	static active = 'off';
	
	constructor () {
		this.enabled = Boolean(config.features.sound && !isMobile);
		if (!this.enabled) return;
		
		if (!Sound.music) {
			Sound.music = new BaseElement('audio')
				.appendTo(document.body)
				.addClass('background-music')
				.DOMElement;
			Sound.music.muted = true;
			Sound.music.loop = true;
			Sound.music.src = config.features.sound;
		}
	}
	
	addButton (parent, addText = true, addClass = null) {
		if (!this.enabled) return;
		
		this.btn = new BaseElement('button')
			.addClass('control-panel__button', 'mute', 'preloader-skip-text', 'slider-sound-btn','sound-btn',addClass)
			.event('click', this.soundHandler.bind(this))
			.appendTo(parent)
			.DOMElement;
		
		this.text = null;
		
		if (addText) {
			this.text = new BaseElement('span')
				.addClass('text', 'language-string')
				.innerHtml(changeLangToCurrent('Unmute'))
				.appendTo(this.btn)
				.DOMElement;
		}
		
		this.icon = new BaseElement('span')
			.addClass('mute__icon')
			.appendTo(this.btn)
			.DOMElement;
		
		setLordIcon('soundOn', this.icon, {
			trigger: 'morph',
			delay: '0',
			primaryColor: '#ffffff',
			secondaryColor: '#ffffff',
		});
		setLordIcon('soundOff', this.icon, {
			trigger: 'morph',
			delay: '0',
			primaryColor: '#ffffff',
			secondaryColor: '#ffffff',
		});
		
		this.icon.dataset.active = Sound.active;
	}
	
	soundHandler () {
		Sound.music.muted = !Sound.music.muted;
		Sound.music.muted ?
			Sound.music.pause() :
			Sound.music.play();
		this.#toggleIcon();
		this.#toggleText();
	}
	
	#toggleIcon () {
		let action;
		
		this.icon.dataset.active === 'on' ?
			action = 'off' :
			action = 'on';
		
		this.icon.dataset.active = action;
		Sound.active = action;
	}
	
	#toggleText () {
		if (this.text) {
			Sound.music.muted ? this.text.innerHTML = changeLangToCurrent('Unmute') : this.text.innerHTML = changeLangToCurrent('Mute');
		}
	}
	
	dispose () {
		if (this.btn) {
			this.btn.remove();
			this.btn = null;
			this.icon = null;
			this.text = null;
		}
	}
	
	static disposeMusic () {
		if (Sound.music) {
			Sound.music.remove();
			Sound.music = null;
		}
	}
	
}
